

const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec))


const searchShippingDayElement = async () => {
  // 中身がレンダリングされるまで待つ
  await sleep(2500)
  for (let i = 0; i < 50; i++) {
      const shippingDayElement = document.querySelector('.Cart__NoteContainer')
      if (shippingDayElement) {
          return shippingDayElement
      }
      await sleep(200)
  }
  return null
}

let shippingDayElement
searchShippingDayElement().then(element => {
  if (element) {
    shippingDayElement = element
  }
})


const searchGiftOptionElement = async () => {
   for (let i = 0; i < 40; i++) {
      const giftOptionElement = document.querySelectorAll('.anygift-option-button__circle')[1]
      if (giftOptionElement) {
          return giftOptionElement
      }
      await sleep(200)
  }
  return null
}


searchGiftOptionElement().then((giftOptionElement) => {
  if (giftOptionElement) {
    const giftOptionObserver = new MutationObserver((mutations) => {
      mutations.forEach((value) => {
        const isGiftSelected = Array.from(value.target.classList).includes('anygift-option-button__circle-active')

        if (isGiftSelected) {
          shippingDayElement.style.display = 'none'
        } else {
          shippingDayElement.style.display = 'block'
        }
      });
    });

    const observerConfig = {
      childList: false,
      attributes: true,
      characterData: false,
      subtree: false,
    };

    giftOptionObserver.observe(giftOptionElement, observerConfig)
  }
})


fetch('/cart.js').then(
    async cart => {
        const res = await cart.json()
        const isGiftEnabledItemInCart = res.items.some(item =>
            item.properties &&
                'ギフト購入' in item.properties &&
                item.properties['ギフト購入'] === '有効',
        )
        if (isGiftEnabledItemInCart) {
          for (let i = 0; i < 40; i++) {
            if (shippingDayElement) {
              shippingDayElement.style.display = 'none'
              return
            }
            await sleep(200)
          }
        }                                        
    },
    error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
    }
);